import { render, staticRenderFns } from "./generateVideo.vue?vue&type=template&id=2cd882fc&scoped=true"
import script from "./generateVideo.vue?vue&type=script&lang=js"
export * from "./generateVideo.vue?vue&type=script&lang=js"
import style0 from "./generateVideo.vue?vue&type=style&index=0&id=2cd882fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd882fc",
  null
  
)

export default component.exports